import { Box, Card, Flex } from '@mantine/core';
import { primaryBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  title: string;
  icon: string;
  iconColor?: string;
  description?: string;
  onClick?: () => void;
};

export const EmptyStateBox = ({ title, icon, iconColor, description, onClick }: Props) => {
  const isClickable = !!onClick;

  return (
    <Box p="md">
      <Flex
        justify="center"
        align="center"
        style={{
          minHeight: 'calc(100vh - 250px)',
          width: '100%',
        }}
      >
        <Card
          shadow="sm"
          padding="xl"
          radius="md"
          withBorder
          style={{
            width: '416px',
            height: '240px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: isClickable ? 'pointer' : 'default',
            backgroundColor: 'white',
          }}
          onClick={onClick}
        >
          <Flex direction="column" align="center" gap="md">
            <Icon
              name={icon}
              variant="outlined"
              size={40}
              color={iconColor || primaryBase}
              style={{ cursor: isClickable ? 'pointer' : 'default' }}
            />
            <Text weight="medium" size="large">
              {title}
            </Text>
            {description && (
              <Text size="small" style={{ textAlign: 'center' }}>
                {description}
              </Text>
            )}
          </Flex>
        </Card>
      </Flex>
    </Box>
  );
};
